import React, { createContext, useContext } from 'react'
import { BaseFieldStore } from '../Stores/BaseFieldStore'

/**
 * React Context для поля формы
 */
export const FormFieldContext = createContext<BaseFieldStore | null>(null)

/**
 * Hook для получения контекста поля
 */
export const useFormFieldContext = (): BaseFieldStore | null => {
    return useContext(FormFieldContext)
}

/**
 * Провайдер контекста поля формы
 */
export interface FormFieldContextProviderProps {
    value: BaseFieldStore
    children: React.ReactNode
}

export const FormFieldContextProvider: React.FC<FormFieldContextProviderProps> = ({
    value,
    children,
}) => <FormFieldContext.Provider value={value}>{children}</FormFieldContext.Provider>
